export function HeaderBanner() {
  return null;
}
